module.exports = __webpack_public_path__ + "static/img/notice_action.45696492.png";